export default {
  'fetch': () => import('isomorphic-fetch'),
  'Proxy': () => import('core-js'),
  'URL': () => import('url-polyfill'),
  'URLSearchParams': () => import('url-search-params-polyfill')
};
